<template>
  <button
    @click="() => $emit('checked', !checked)"
    :class="{ checked: checked }"
    :disabled="disabled"
    class="custom-checkbox"
    type="button"
  >
    <div class="checked-state" v-show="checked">
      <i class="fa fa-check"></i>
    </div>
  </button>
</template>

<script>
export default {
  props: {
    checked: {
      type: Boolean,
      required: true,
    },
    disabled: {
      type: Boolean,
      default: true,
    },
  },
};
</script>

<style lang="scss" scoped>
@import '../../../sass/variables';
@import '../../../sass/mixins';


.custom-checkbox {
  width: 1rem;
  height: 1rem;
  border: 1px solid #d9d9d9;
  border-radius: 4px;
  background: white;
  padding: 0px;

  &.checked {
    border: 1px solid $salesflow-primary;
  }

  .checked-state {
    width: 100%;
    height: 100%;
    display: flex;
    align-items: center;
    justify-content: center;
    background: $salesflow-primary;

    color: white;
    font-size: 0.625rem;
    line-height: 100%;
  }
}

</style>
